declare interface gtmWindow extends Window {
    dataLayer?: Record<string, unknown>[];
    gtag?: (...args: unknown[]) => void;
}
declare const window: gtmWindow;

export function TrackPurchase(opts: {
    orderID: string;
    invoiceNumber: string;
    value: number;
    numItems: number;
}): void {
    if (!window.dataLayer) {
        return;
    }

    window.dataLayer.push({
        'event': 'purchase',
        'orderId': opts.orderID,
        'invoiceNumber': opts.invoiceNumber,
        'value': opts.value,
        'currency': 'USD',
        'numItems': opts.numItems,
        'origin': window.location.href,
    });

    // The GTM containers are shared per theme while each site has its own GA4
    // property, and a container's GA4 purchase tag can only forward to one of
    // them (#9547) — so send the purchase to the page's own property directly.
    // GA4 dedupes purchase events by transaction_id, which keeps the property
    // the container DOES forward to from double-counting.
    if (window.gtag) {
        window.gtag('event', 'purchase', {
            'transaction_id': opts.invoiceNumber,
            'value': opts.value,
            'currency': 'USD',
        });
    }
}
